/**
 * Fetch Wrapper with Cookie-Based JWT Authentication
 * 
 * Cookie-Based Authentication:
 * - JWT tokens are stored in HttpOnly cookies (managed by backend)
 * - Browser automatically sends cookies with every request
 * - NO Authorization headers needed
 * - MUST include `credentials: 'include'` for cookies to work
 * 
 * @param {string} url - URL to fetch
 * @param {object} options - Fetch options
 * @returns {Promise<Response>} Fetch response
 */
export const fetchWithJWT = async (url, options = {}) => {
  const fetchOptions = {
    ...options,
    credentials: 'include',
    headers: {
      ...options.headers,
    },
  };
  
  const response = await fetch(url, fetchOptions);
  
  if (response.status === 401) {
    const SSO = (await import("../../sso/index")).default;
    SSO.redirectToSignInUrl();
  }
  
  return response;
};

export default fetchWithJWT;
